import { render, staticRenderFns } from "./CourseAffiliates.vue?vue&type=template&id=800786bc&"
import script from "./CourseAffiliates.vue?vue&type=script&lang=js&"
export * from "./CourseAffiliates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports